import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionHotelPolicyKidsPolicyRoot } from "./kids-policy";
import { QuestionHotelPolicyKidsPolicyDetail } from "./kids-policy-detail";

import type { HotelPolicyCategoriesAndManagerStore } from "../../../../store/categories";

type Props = {
	kidsPolicy: HotelPolicyCategoriesAndManagerStore["kidsPolicy"];
};

export const QuestionHotelPolicyKidsPolicy = ({ kidsPolicy }: Props) => {
	return (
		<>
			<FeatureIslandMainWithCategoryWrapper categoryStore={kidsPolicy}>
				<QuestionHotelPolicyKidsPolicyRoot />
			</FeatureIslandMainWithCategoryWrapper>

			<FeatureIslandMainWithCategoryWrapper categoryStore={kidsPolicy} islandTitle={"キッズポリシーの詳細設定"}>
				<QuestionHotelPolicyKidsPolicyDetail />
			</FeatureIslandMainWithCategoryWrapper>
		</>
	);
};

QuestionHotelPolicyKidsPolicy.displayName = "QuestionHotelPolicyKidsPolicy";
